import { Checkbox as FASTCheckbox } from '@microsoft/fast-components';
import { foundationCheckboxStyles as styles } from './checkbox.styles';
import { foundationCheckboxTemplate as template } from './checkbox.template';
/**
 * @tagname %%prefix%%-checkbox
 */
export class Checkbox extends FASTCheckbox {
}
// explicitly declaring for extensibility
export const foundationCheckboxShadowOptions = undefined;
export const defaultCheckboxConfig = {
    checkedIndicator: `
    <svg
      aria-hidden="true"
      part="checked-indicator"
      class="checked-indicator"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.143 12.6697L15.235 4.5L16.8 5.90363L8.23812 15.7667L3.80005 11.2556L5.27591 9.7555L8.143 12.6697Z"
      />
    </svg>
  `,
    indeterminateIndicator: `
    <div part="indeterminate-indicator" class="indeterminate-indicator"></div>
  `,
};
/**
 * The Foundation Checkbox
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-checkbox\>
 */
export const foundationCheckbox = Checkbox.compose(Object.assign({ baseName: 'checkbox', template,
    styles, shadowOptions: foundationCheckboxShadowOptions }, defaultCheckboxConfig));
